import Form from 'src/utils/Form.js'

class Email extends Form {
    constructor(data, config = null) {
        super(data, config || Form.config)
    }

    sendBulkEmail(then) {
        return super.post('users/send-email').then(then)
    }
}

export default Email
